import { render } from "./Text1.vue?vue&type=template&id=d4ceb4e8&scoped=true"
import script from "./Text1.vue?vue&type=script&lang=js"
export * from "./Text1.vue?vue&type=script&lang=js"

import "./Text1.vue?vue&type=style&index=0&id=d4ceb4e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ceb4e8"]])

export default __exports__